import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const STATS = [
  { icon: '👨‍👩‍👧‍👦', number: 50000, suffix: '+', label: 'Lives Impacted', sub: 'Across Tamil Nadu & beyond' },
  { icon: '🏫', number: 85, suffix: '+', label: 'Schools Supported', sub: 'Rural & tribal areas' },
  { icon: '💊', number: 12000, suffix: '+', label: 'Medical Checkups', sub: 'Free healthcare camps' },
  { icon: '🌾', number: 3200, suffix: '+', label: 'Families Supported', sub: 'Sustainable livelihoods' },
];

function useCountUp(target, duration = 2000, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = timestamp => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function StatCard({ stat, inView }) {
  const count = useCountUp(stat.number, 2200, inView);

  const fmt = n => {
    if (n >= 1000) {
      const k = n / 1000;
      return k % 1 === 0 ? `${k}K` : `${k.toFixed(1)}K`;
    }
    return n.toString();
  };

  return (
    <div className="stat-card" role="figure" aria-label={`${stat.number}${stat.suffix} ${stat.label}`}>
      <span className="stat-icon" aria-hidden="true">{stat.icon}</span>
      <div className="stat-number">
        {fmt(count)}<span className="stat-suffix">{stat.suffix}</span>
      </div>
      <div className="stat-label">{stat.label}</div>
      <div className="stat-sub">{stat.sub}</div>
    </div>
  );
}

export default function Stats() {
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats" ref={ref} aria-label="Impact statistics">
      <div className="container">
        <div className="stats-grid" role="list">
          {STATS.map(stat => (
            <StatCard key={stat.label} stat={stat} inView={inView} />
          ))}
        </div>
      </div>
    </section>
  );
}
